export const getCoordinatesAsString = (
  xIndex: number,
  yIndex: number,
): string => `${xIndex},${yIndex}`
